import { createAction } from 'redux-actions';

export const FETCHED_STORES = 'FETCHED_STORES';
export const FETCHED_ROOMS = 'FETCHED_ROOMS';
export const FETCHED_FOOD_STORES = 'FETCHED_FOOD_STORES';

export const fetchedStores = createAction(FETCHED_STORES, data => data);
export const fetchedRooms = createAction(FETCHED_ROOMS, data => data);
export const fetchedFoodStores = createAction(FETCHED_FOOD_STORES, data => data);
